<template>
  <div class="mx-auto">
    <div class="login-page"><NewLogin /></div>
  </div>
</template>

<script>
import NewLogin from "../components/ui/Login/New-Login.vue";
export default {
  components: { NewLogin },
  data: () => ({
    startedLogin: false,
    baseUrl: process.env.VUE_APP_API_BASE_URL,
    image: require("@/assets/login-bg.webp")
  }),
  computed: {
    disableLoginButton() {
      return this.$store.getters["user/showDevLoginDialog"];
    }
  },
  methods: {
    getSsoLoginUrl() {
      return !this.disableLoginButton
        ? this.$store.getters["user/ssoLoginUrl"]
        : "#";
    }
  }
};
</script>

<style scoped>
.login-page {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}
.login-page > * {
  margin: auto 0;
}
</style>
